import { useMemo } from 'react';
import { Outlet, useOutletContext, useParams } from 'react-router-dom';
import { useParameters } from '@web/utils/src';
import { InnerNavigation } from '@/components/InnerNavigation';
import { Retailer } from '@/types';
import { RetailerContainer } from './Orders/components';
import { OrdersQuery, useOrdersQuery } from './Orders/orders.generated';

type ContextType = OrdersQuery | undefined;

const DocumentsLayout = () => {
  const params = useParameters<{ retailerId: string }>();

  const [{ data }] = useOrdersQuery({
    variables: {
      retailerID: params.retailerId,
    },
  });

  const showInvoicesTab = useMemo(
    () => !data?.retailer.settings.hideInvoices || false,
    [data?.retailer.settings.hideInvoices],
  );

  return (
    <div className="flex min-h-100vh font-rg w-full">
      <div className="container">
        <RetailerContainer retailers={data?.retailers as Retailer[]} />
        <InnerNavigation showInvoicesTab={showInvoicesTab} />
        <hr className="text-secondary-grey" />
        <Outlet context={data} />
      </div>
    </div>
  );
};

export default DocumentsLayout;

export function useDocuments() {
  return useOutletContext<ContextType>();
}
